<template>
    <div class="valve">

        <div class="loading" v-if="loading">
            Loading...
        </div>

        <div v-if="error" class="error">
            {{ error }}
        </div>


        <div class="valve-wrapper">
            <div class="valve-info" v-bind:class="{active: loading === false}" :key="valve.slug">


                    <h1 class="valve-info__title">
                        {{ valve.title }}
                        <span class="valve-info__nav-btns">
                             <router-link :to="'/valve/' + valve.prevProduct"  v-if="valve.prevProduct" class="valve-info__nav-btn prev" aria-label="Previous"><i class="icon-arrow-bold-left"></i></router-link>
                            <router-link :to="'/valve/' + valve.nextProduct" v-if="valve.nextProduct" class="valve-info__nav-btn next" aria-label="Next"><i class="icon-arrow-bold-right"></i></router-link>
                        </span>
                    </h1>

                    <p> <span v-html="valve.summary">{{ valve.summary }}</span></p>

                <!--EmbedID: {{valve.sketchfabEmbeds[0].embedID}}-->
                <div class="related-items">

                    <span class="modelviewer-sidebar__title" v-if="hasRelatedProducts">Explore related</span>
                    <div class="related-item-accordion">

                        <v-collapse-wrapper v-if="relatedRotors" v-on:beforeOpen="accordionBeforeOpen" v-on:beforeClose="accordionBeforeClose">
                            <span class="related-item-accordion__header" v-collapse-toggle>
                                <strong>Rotors</strong> ({{relatedRotors.length }})
                            </span>
                            <div class="related-item-accordion__content" v-collapse-content>
                                <router-link v-for="relatedProduct in relatedRotors"  :key="relatedProduct.slug" :to="'/valve/' + relatedProduct.slug" class="related-product">
                                    <div>
                                        <div class="related-product-preview">
                                            <div>
                                                <div class="related-product-preview__image-container">
                                                    <img :src="relatedProduct.image" v-bind:alt="relatedProduct.title">
                                                </div>
                                                <span class="related-product-preview__title">{{relatedProduct.title}}</span>
                                            </div>
                                        </div>
                                        <span>{{ relatedProduct.title }}, </span>
                                    </div>
                                </router-link>
                            </div>
                        </v-collapse-wrapper>

                        <v-collapse-wrapper v-if="relatedKits" v-on:beforeOpen="accordionBeforeOpen" v-on:beforeClose="accordionBeforeClose">
                            <span class="related-item-accordion__header" v-collapse-toggle>
                                <strong>Kits</strong> ({{relatedKits.length }})
                            </span>
                            <div class="related-item-accordion__content" v-collapse-content>
                                <router-link v-for="relatedProduct in relatedKits"  :key="relatedProduct.slug" :to="'/valve/' + relatedProduct.slug"  class="related-product">
                                    <div>
                                        <div class="related-product-preview">
                                            <div>
                                                <div class="related-product-preview__image-container">
                                                    <img :src="relatedProduct.image" v-bind:alt="relatedProduct.title">
                                                </div>
                                                <span class="related-product-preview__title">{{relatedProduct.title}}</span>
                                            </div>
                                        </div>
                                        <span>{{ relatedProduct.title }}, </span>
                                    </div>
                                </router-link>
                            </div>
                        </v-collapse-wrapper>

                        <v-collapse-wrapper v-if="relatedAccessories" v-on:beforeOpen="accordionBeforeOpen" v-on:beforeClose="accordionBeforeClose">
                            <span class="related-item-accordion__header" v-collapse-toggle>
                                <strong>Accessories</strong> ({{relatedAccessories.length }})
                            </span>
                            <div class="related-item-accordion__content" v-collapse-content>
                                <router-link v-for="relatedProduct in relatedAccessories"  :key="relatedProduct.slug" :to="'/valve/' + relatedProduct.slug"  class="related-product">
                                    <div>
                                        <div class="related-product-preview">
                                            <div>
                                                <div class="related-product-preview__image-container">
                                                    <img :src="relatedProduct.image" v-bind:alt="relatedProduct.title">
                                                </div>
                                                <span class="related-product-preview__title">{{relatedProduct.title}}</span>
                                            </div>
                                        </div>
                                        <span>{{ relatedProduct.title }}, </span>
                                    </div>
                                </router-link>
                            </div>
                        </v-collapse-wrapper>

                        <v-collapse-wrapper v-if="relatedOtherEquipments" v-on:beforeOpen="accordionBeforeOpen" v-on:beforeClose="accordionBeforeClose">
                            <span class="related-item-accordion__header" v-collapse-toggle>
                                <strong>Other Equipment</strong> ({{relatedOtherEquipments.length }})
                            </span>
                            <div class="related-item-accordion__content" v-collapse-content>
                                <router-link v-for="relatedProduct in relatedOtherEquipments"  :key="relatedProduct.slug" :to="'/valve/' + relatedProduct.slug"  class="related-product">
                                    <div>
                                        <div class="related-product-preview">
                                            <div>
                                                <div class="related-product-preview__image-container">
                                                    <img :src="relatedProduct.image" v-bind:alt="relatedProduct.title">
                                                </div>
                                                <span class="related-product-preview__title">{{relatedProduct.title}}</span>
                                            </div>
                                        </div>
                                        <span>{{ relatedProduct.title }}, </span>
                                    </div>
                                </router-link>
                            </div>
                        </v-collapse-wrapper>

                        <v-collapse-wrapper v-if="relatedValves" v-on:beforeOpen="accordionBeforeOpen" v-on:beforeClose="accordionBeforeClose">
                            <span class="related-item-accordion__header" v-collapse-toggle>
                                <strong>Valves</strong> ({{relatedValves.length }})
                            </span>
                            <div class="related-item-accordion__content" v-collapse-content>
                                <router-link v-for="relatedProduct in relatedValves"  :key="relatedProduct.slug" :to="'/valve/' + relatedProduct.slug"  class="related-product">
                                    <div>
                                        <div class="related-product-preview">
                                            <div>
                                                <div class="related-product-preview__image-container">
                                                    <img :src="relatedProduct.image" v-bind:alt="relatedProduct.title">
                                                </div>
                                                <span class="related-product-preview__title">{{relatedProduct.title}}</span>
                                            </div>
                                        </div>
                                        <span>{{ relatedProduct.title }}, </span>
                                    </div>
                                </router-link>
                            </div>
                        </v-collapse-wrapper>





                    </div>


                </div>

<!--                <span class="modelviewer-sidebar__title" v-if="hasRelatedVideos">Videos</span>-->


<!--                <div class="modelviewer-sidebar__related-videos">-->
<!--                    <div class="video-item__embed"  v-for="relatedVideo in relatedVideos">-->
<!--                        <span class="video-item__preview">{{ relatedVideo.title }}</span>-->
<!--                        <div  :class="['wistia_embed popover=true popoverAnimateThumbnail=true video-item__image', computedClass, ('wistia_async_'+relatedVideo.embedID)]" >-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <span class="modelviewer-sidebar__divider"></span>

                <a v-if="valve.url" v-bind:href="valve.url" target="_blank" class="btn-square darkblue align-icon-right modelviewer-sidebar__btn ">View Product <i class="icon-arrow-right2"></i></a>
                <a v-if="valve.specsheetLink" v-bind:href="valve.specsheetLink" target="_blank" class="btn-square gray align-icon-right  modelviewer-sidebar__btn">Download Specs <i class="icon-arrow-right2"></i></a>

            </div>
            <!---->
            <div class="valve-view">
                <div class="valve-views" v-if="valveRenders.length > 1">
                    <button v-for="render in valveRenders" v-on:click="doEmbed(render.embedID)">{{render.renderTitle}}</button>
                </div>
                <transition name="fade">
                <span v-if="valveLoading" class="valve-loader">
                    <div class="sk-circle">
  <div class="sk-circle1 sk-child"></div>
  <div class="sk-circle2 sk-child"></div>
  <div class="sk-circle3 sk-child"></div>
  <div class="sk-circle4 sk-child"></div>
  <div class="sk-circle5 sk-child"></div>
  <div class="sk-circle6 sk-child"></div>
  <div class="sk-circle7 sk-child"></div>
  <div class="sk-circle8 sk-child"></div>
  <div class="sk-circle9 sk-child"></div>
  <div class="sk-circle10 sk-child"></div>
  <div class="sk-circle11 sk-child"></div>
  <div class="sk-circle12 sk-child"></div>
</div>
                    <span>Now Loading...</span>
                </span>
                </transition>
                <div id="embed-wrapper">

                </div>
                <div class="valve-annotations" v-if="!valveLoading">
                    <button class="valve-annotation" v-for="annotation in annotations"><span><span></span></span>{{annotation.name}}</button>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
// @ is an alias to /src
import ValveTile from '@/components/ValveTile.vue'
import EmbedView from '@/components/EmbedView.vue'
import axios from 'axios'
import VueCollapse from 'vue2-collapse'

export default {
  name: 'valve-view',
  //  props: [ 'valve'],
    //    data: function() {
//        return {
//            embedID: this.initialEmbedID
//        }
//    },
    data() {
        return {
            valve: null,
            embedID: null,
            valveRenders: null,
            loading: false,
            error: null,
            relatedRotors: null,
            relatedKits: null,
            relatedAccessories: null,
            relatedOtherEquipments: null,
            relatedValves: null,
             relatedVideos: null,
            annotations: null,
            hasRelatedProducts: false,
            hasRelatedVideos: false,
            isReady: false,
            valveLoading: false,
        }
    },
    methods: {
      accordionBeforeOpen(vm){
          // Add class to accordion header
          vm.nodes.toggle.classList.add('open');
      },
        accordionBeforeClose(vm){
            // Remove class to accordion header
            vm.nodes.toggle.classList.remove('open');
        },
        fetchData() {



            this.error = this.valve = null
            this.loading = true
            this.isReady = false


            axios
                .get('/rotary-valves/'+this.$route.params.slug+'.json')
                .then(response => {
                    this.loading = false
                    this.isReady = true
                    this.valve = response.data.data[0]

                    // Get all valve renders
                    this.valveRenders = response.data.data[0].sketchfabEmbeds;

                    // Get related products
                    this.relatedRotors = response.data.data[0].relatedRotors;
                    this.relatedKits = response.data.data[0].relatedKits;
                    this.relatedAccessories = response.data.data[0].relatedAccessories;
                    this.relatedOtherEquipments = response.data.data[0].relatedOtherEquipment;
                    this.relatedValves = response.data.data[0].relatedValves;
                    this.relatedVideos = response.data.data[0].relatedVideos;

                    if (this.relatedRotors || this.relatedKits || this.relatedAccessories || this.relatedOtherEquipments || this.relatedValves){
                        this.hasRelatedProducts = true
                    } else {
                        this.hasRelatedProducts = false
                    }


                    if (this.relatedVideos ){
                        this.hasRelatedVideos = true
                    } else {
                        this.hasRelatedVideos = false
                    }



                    // Set initial embedID from first render
                    this.embedID = this.valveRenders[0].embedID;


                    console.log(this.valve)
                    this.doEmbed(this.embedID)
                })


        },
        doEmbed(embedID){
            console.log("DOIN EMBED!");
//            console.log("valve:");
//            console.log(this.valve);
//            console.log(embedID);

            if (document.body.contains(document.getElementById("api-frame"))) {
                document.getElementById("api-frame").remove();
            }


            let _this = this

            var iframe;
            iframe = document.createElement('iframe');
            iframe.src = '';
            iframe.id = 'api-frame';
            iframe.title = '3D product viewer';
            //iframe.style.display = 'none';



            setTimeout(function(){
                console.log("#########");
                document.getElementById("embed-wrapper").appendChild(iframe);
                console.log(document.getElementById("embed-wrapper"));
                console.log("#########");

            }, 500);




            console.log("DOING A THING!");
            console.log(iframe);
            var version = '1.0.0';
            var client = new Sketchfab( iframe );
            var urlid = embedID;

            
            //console.log(data);

            _this.valveLoading = true

            client.init( urlid, {
                //transparent: 1,
                // ui_controls: 0,
                ui_annotations: 0,
                ui_inspector: 0,
                ui_vr: 0,
                ui_settings: 0,
                ui_watermark_link: 0,
                autostart: 1,
                camera: 0,
                scrollwheel: 1,
                ui_infos: 0,
                ui_stop: 0,
                transparent: 1,
//              orbit_constraint_zoom_in: 30,
//              orbit_constraint_zoom_out: 95,
                double_click: 0,
                success: function onSuccess( api ){
                    console.log("SUCCESS");
                    console.log(api);
                    api.stop();
                    api.start();




                    api.addEventListener( 'viewerready', function() {
                        console.log("VIEWER READY!");
                        // Fade out loading on viewer ready

                        _this.valveLoading = false

                        // Get annotations. Display in nav
                        api.getAnnotationList( function( err, annotations ) {
                           // modelviewerAnnotations.html('');
//                            $.each(annotations, function( key, annotation ) {
//                                modelviewerAnnotations.append('<button class="modelviewer-annotation" target-annotation='+key+'>'+(key + 1)+'. '+annotation.name+'</button>');
//                            });
                            console.log(annotations);
                            console.log(_this);
                            _this.annotations = annotations;
                            // Select first annotation automatically
                            //api.gotoAnnotation(0);
                            //$('.modelviewer-annotation:first-child').addClass('active');
                        });

                        // On clicking annotation button
                        $(document).on('click', '.valve-annotation', function () {
                            $('.valve-annotation').removeClass('active')
                            $(this).addClass('active')
                            //api.gotoAnnotation($(this).attr('target-annotation'));
                            api.gotoAnnotation($(this).index())
                        });
                    });



                    api.addEventListener( 'annotationFocus', function( index ) {
                        console.log(index);
                        console.log(typeof(index));
                        console.log('Reached annotation ' + index + 1);
                        $('.valve-annotation').removeClass('active');
                        $('.valve-annotation:nth-child('+ (index + 1) +')').addClass('active');
                    } );

                },
                error: function onError() {
                    console.log( 'Viewer error' );
                }
            });

        }
    },
    watch: {
        // call again the method if the route changes
//        '$route' (to, from) {
//            this.fetchData()
//        }
        '$route': 'fetchData'
    },
    created() {
        this.fetchData()
    },
    mounted () {
//        let sketchfabScript = document.createElement('script')
//        sketchfabScript.setAttribute('src', 'https://static.sketchfab.com/api/sketchfab-viewer-1.3.1.js')
//        document.head.appendChild(sketchfabScript)

    },
  components: {
      EmbedView
  }
}
</script>
